import {Component, Output, Input, EventEmitter} from '@angular/core';
import {PaginationControlsDirective} from 'ngx-pagination';

@Component({
    selector: 'pagination',
    template: require('./pagination.template.html')
})
export class Pagination {

    @Output('onPageChange') onPageChange: EventEmitter<any> = new EventEmitter();
    @Input('onlyArrows') onlyArrows: boolean;

    handlePageChange(pagination: PaginationControlsDirective, page: any) {
        if (page > 0
            && page <= pagination.getLastPage()
            && page !== pagination.getCurrent()) {
            this.onPageChange.emit(page);
        }
    }

    handleClickPrevious(pagination: PaginationControlsDirective) {

        if (!pagination.isFirstPage()) {
            pagination.previous();
        }
    }

    handleClickNext(pagination: any) {
        if (!pagination.isLastPage()) {
            pagination.next();
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/pagination/pagination.component.ts